import {Trailer} from 'app/blocks/model/trailer.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {ITrailer} from 'app/blocks/model/trailer.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class TrailerService extends EntityCrudService<ITrailer> {
    constructor(http: HttpClient) {
        super(http, Resource.TRAILERS, (obj?) => new Trailer(obj));
    }
}
